import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Sidebar } from './Sidebar';

interface StockFilterProps {
  onClose: () => void;
  onChange: (stockFilters: [boolean, boolean]) => void;
  selectedStockFilters: [boolean, boolean];
  runFilter: () => void;
}

export const StockFilter: React.FC<StockFilterProps> = ({
  onClose,
  onChange,
  selectedStockFilters,
  runFilter
}) => {
  const onChangeInStockFilter = (_evt: React.SyntheticEvent, val: boolean) => {
    const newSelectedStockFilters: [boolean, boolean] = [val, selectedStockFilters[1]];
    onChange(newSelectedStockFilters);
  };

  const onChangeOutOfStockFilter = (_evt: React.SyntheticEvent, val: boolean) => {
    const newSelectedStockFilters: [boolean, boolean] = [selectedStockFilters[0], val];
    onChange(newSelectedStockFilters);
  };

  return (
    <Sidebar title="Stock Filter" onClose={onClose} showDoneButton={false}>
      <div style={{ padding: 24 }}>
        <div>
          <FormControlLabel
            onChange={onChangeInStockFilter}
            control={<Checkbox />}
            label="In stock"
            checked={selectedStockFilters[0]}
          />
        </div>
        <div>
          <FormControlLabel
            onChange={onChangeOutOfStockFilter}
            control={<Checkbox />}
            label="Out of stock"
            checked={selectedStockFilters[1]}
          />
        </div>
      </div>
    </Sidebar>
  );
};
